import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function NotFoundPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-gray-50 py-16 px-4">
      <SEOHead
        title="404 – Side ikke fundet – Vognmand & Entreprenør DBM aps"
        description="Siden du leder efter findes desværre ikke."
      />

      <div className="max-w-md w-full bg-white p-8 sm:p-10 rounded shadow-md border border-gray-200 text-center">
        <div className="text-black font-black text-6xl mb-2">404</div>
        <h1 className="text-2xl font-bold text-gray-900 uppercase tracking-tight mb-4">
          Side ikke fundet
        </h1>
        <p className="text-gray-600 text-sm mb-8 leading-relaxed">
          Siden du leder efter findes desværre ikke eller er flyttet.
        </p>

        <Link
          to="/"
          className="inline-block bg-gray-900 hover:bg-black text-white font-bold px-8 py-3 rounded uppercase tracking-wider text-xs transition-colors shadow-md"
        >
          Tilbage til forsiden
        </Link>
      </div>
    </div>
  );
}
